import { html } from "lit";
import { getDummyText, renderStandardPictureElement } from "../../../../utils";
import { ProductPartType } from "./shared";

const items: ProductPartType[] = [
    {
        title: "TruTops Boost",
        text: getDummyText(380),
    },
    {
        title: "Software",
        text: getDummyText(380),
    },
];

const renderTile = (item: ProductPartType) => html`
    <!-- ProductImageTextSingleTeaser -->
    <div class="ux-row ux-u-mb-fluid-s">
        <div class="ux-col-12 ux-col-sm-6">
            <div class="block-image">
                ${renderStandardPictureElement({
                    width: 1700,
                    height: 800,
                })}
            </div>
        </div>
        <div class="ux-col-12 ux-col-sm-6">
            <h3 class="ux-text-headline ux-text-headline--small">
                ${item.title}
            </h3>
            <p class="ux-text-normal">${item.text}</p>
            <div class="block-button">
                <a href="#" class="ux-button" data-tracking=""> Zum Produkt </a>
            </div>
        </div>
    </div>
`;

export const ProductImageTextSingleTeaserTemplate = () => html`
    <div class="ux-t-container">
        <!-- BEGIN Loop -->
        ${items.map(renderTile)}
        <!-- End Loop -->
    </div>
`;

export const TabSoftware = () => html`
    <div id="tabSoftware">${ProductImageTextSingleTeaserTemplate()}</div>
`;
